"use client";

import React from "react";
import {
  QueryClient,
  QueryClientProvider,
  type DefaultOptions,
} from "@tanstack/react-query";

const queryDefaults: DefaultOptions["queries"] = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  refetchOnWindowFocus: false,
  retry: 1,
};

const mutationDefaults: DefaultOptions["mutations"] = {
  retry: 0,
};

const queryClientDefaults: DefaultOptions = {
  queries: queryDefaults,
  mutations: mutationDefaults,
};

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: queryClientDefaults,
  });
}

type QueryProviderProps = {
  children: React.ReactNode;
};

export default function QueryProvider({ children }: QueryProviderProps) {
  const [queryClient] = React.useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
